import { useBackLayer } from '@heltarchat/ui';

/**
 * Binds a layer the app draws itself (a viewer, a panel, a selection mode) to
 * the back button: while `active`, Back calls `onBack`, which must close it.
 * Overlays from `@heltarchat/ui` are bound already.
 *
 *   useBackDismiss(isOpen, () => setIsOpen(false));
 */
export const useBackDismiss = useBackLayer;

/** The same binding as an element, for a conditionally rendered layer. */
export function BackDismiss({ onBack }: { onBack: () => void }) {
  useBackLayer(true, onBack);
  return null;
}
